import React from 'react';
import { AnnouncementBar } from '../components/AnnouncementBar';
import { Footer } from '../components/Footer';
export const PrivacyPolicy = () => {
  return <div className="w-full min-h-screen bg-white flex flex-col" data-id="element-297">
      <AnnouncementBar data-id="element-298" />
      <main className="flex-1 w-full" data-id="element-299">
        <div className="max-w-[780px] mx-auto px-4 md:px-6 py-12 md:py-20" data-id="element-300">
          <h1 className="font-playfair text-[28px] md:text-[32px] text-primary mb-8" data-id="element-301">
            Privacy Policy
          </h1>

          <div className="font-lato text-[16px] text-body" style={{
          lineHeight: 1.8
        }} data-id="element-302">
            <p className="mb-5" data-id="element-303">
              <strong data-id="element-304">Last updated: January 2026</strong>
            </p>

            <p className="mb-5" data-id="element-305">
              We collect only the information necessary to process your purchase
              and deliver your digital products. This includes your name, email
              address, and payment information processed securely through our
              payment provider.
            </p>

            <p className="mb-5" data-id="element-306">
              We do not sell, trade, or transfer your personal information to
              outside parties. Your data is used solely to fulfill your order
              and send you relevant product updates.
            </p>

            <p className="mb-5" data-id="element-307">
              You may request deletion of your data at any time by contacting us
              through our payment platform.
            </p>

            <p className="mb-8" data-id="element-308">
              This website uses cookies to improve your browsing experience. By
              using this site, you consent to our use of cookies.
            </p>

            <a href="#/" className="font-lato text-[15px] hover:underline" style={{
            color: '#957DAD'
          }} data-id="element-309">
              ← Back to main page
            </a>
          </div>
        </div>
      </main>
      <Footer data-id="element-310" />
    </div>;
};